module.exports = __webpack_public_path__ + "img/addSchedule.6ffe9355.svg";